import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { Teacher } from './../models/teacher';

@Injectable({
    providedIn: 'root'
})

export class TeacherService {
    controller = 'Teacher';

    constructor(private base: BaseService) { }

    get(id: number): Observable<ApiObjectData> {
        return this.base.get(id, this.controller + '/GetTeacherById');
    }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetAllTeachers');
    }

    getByUserId(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetByUserId/' + id)
    }

    
    getTeacherNotification(id: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetTeacherNotification/' + id)
    }

    save(obj: Teacher) {
        return this.base.save(this.controller + '/RegisterTeacher', obj);
    }

    remove(id: number) {
        return this.base.remove(this.controller, id);
    }
}